module.exports = __webpack_public_path__ + "img/culture_icon3.89c2af99.png";